import type { FC } from 'react';
import { ContestLogo } from '../component/contest-logo';
import { SuperStarLogo } from '../component/superstar-logo';
import type { FlagShipCardProps } from '../type';

export const MAX_ITEMS = 4;

export const filterItems = (items: FlagShipCardProps['offer']['items']) => {
  return items?.slice(0, MAX_ITEMS);
};

export const BadgeContent: FC<
  Pick<FlagShipCardProps['offer'], 'hasContest' | 'badgeIcon'> & {
    className?: string;
  }
> = ({
  badgeIcon,
  hasContest,
  className = 'absolute -left-4 -top-4 w-9 h-9',
}) => {
  if (badgeIcon) {
    return <SuperStarLogo className={className} logoUrl={badgeIcon} />;
  }
  if (hasContest) {
    return <ContestLogo className={className} />;
  }
  return null;
};
